import React from 'react';

export default function DataTable({ props: p, dir }) {
  const rows = p.rows || p.items || [];
  const columns = p.columns || (rows[0] && !Array.isArray(rows[0]) ? Object.keys(rows[0]) : []);
  const arrayRows = rows.length > 0 && Array.isArray(rows[0]);

  return (
    <div className="ui-data-table-wrap" dir={dir}>
      {p.title && <div className="ui-part-title">{p.title}</div>}
      <table className="ui-data-table">
        <thead>
          <tr>
            {columns.map((c) => <th key={c}>{c}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {arrayRows
                ? columns.map((_, j) => <td key={j}>{row[j] ?? ''}</td>)
                : columns.map((c) => <td key={c}>{row[c]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
